import { Box, TableCell, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
// import FormElements from 'pages/formBuilder/formElements/FormElements';

export const joditEditorButtonConfig = [
	'undo',
	'redo',
	'|',
	'bold',
	'italic',
	'underline',
	'strikethrough',
	'symbols',
	'|',
	'ul',
	'ol',
	'|',
	'outdent',
	'indent',
	'align',
	'lineHeight',
	'|',
	'font',
	'fontsize',
	'brush',
	'paragraph',
	'|',
	'image',
	'table',
	'link',
	'|',
	'hr',
	'eraser',
	'copyformat',
	// 'selectall',
	'|',
	'fullsize',
	'source',
	'preview',
	// 'print',
];

export const validateInput = (e, value) => {
	let fieldName = formatName(e?.field);

	if (!value) {
		return Promise.reject(`${fieldName} is required.`);
	} else if (/^\s+$/.test(value)) {
		return Promise.reject('Input cannot contain only spaces.');
	} else if (/^[^\w\s]+$/.test(value)) {
		return Promise.reject('Input cannot contain only special characters.');
	} else if (/^\d+$/.test(value)) {
		return Promise.reject('Input cannot consist solely of numbers.');
	} else if (/^[\d\W_]+$/.test(value)) {
		return Promise.reject('Input cannot consist only special char & numbers.');
	} else if (value.startsWith(' ')) {
		return Promise.reject('Input starts with whitespace');
	} else if (value.endsWith(' ')) {
		return Promise.reject('Input ends with whitespace');
	} else {
		return Promise.resolve();
	}
};

function formatName(name) {
	return name
		.replace(/([A-Z])/g, ' $1') // insert space before capital letters
		.trim() // remove leading/trailing spaces
		.replace(/^\w/, (c) => c.toUpperCase()); // capitalize first character
}

export const customTabsSX = {
	'& .MuiBox-root': {
		border: 'none',
	},
	'& .MuiTabs-flexContainer': {
		gap: '5px',
	},
	'& .MuiTab-root': {
		backgroundColor: '#f2f2f2',
		border: '1px solid #e5e5e5',
		borderRadius: '6px 6px 0 0',
		opacity: 1,
	},
	'& .Mui-selected': {
		backgroundColor: '#e0e0e0',
		border: '1px solid #bababa',
	},
};

export function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export const TableStatusMap = {
	Active: 'Active',
	Inactive: 'Inactive',
	NEW_INACTIVE: 'W-I-P',
	'W-I-P': 'W-I-P',
	Onboarded: 'W-I-P',
	Deactivated: 'Inactive',
	draft: 'Draft',
	Draft: 'Draft',
	Closed: 'Closed',
	'Re-Open': 'Reopened',
	Reopened: 'Reopened',
	Drafts: 'Draft',
	Complete: 'Complete',
	Incomplete: 'Incomplete',
	'Went-Live': 'Went-Live',
};

export const TableStatusMapIcon = {
	Active: 'Active',
	Inactive: 'Deactivated',
	NEW_INACTIVE: 'Inactive',
	NEW_VERSION_INACTIVE: 'Inactive',
	'W-I-P': 'Inactive',
	Onboarded: 'Inactive',
	Deactivated: 'Deactivated',
	Closed: 'Closed',
	Reopened: 'Reopened',
	'Went-Live': 'Went-Live',
};

export const TabsItemFour = [
	{
		label: 'Active',
		icon: 'active',
		data: 'Active',
	},
	{
		label: 'W-I-P',
		icon: 'inactive',
		data: 'W-I-P',
	},
	{
		label: 'Inactive',
		icon: 'deactivated',
		data: 'Inactive',
	},
	{
		label: 'All',
		icon: 'all',
		data: 'All',
	},
];
export const TabsItemThree = [
	{
		label: 'Active',
		icon: 'active',
		data: 'Active',
	},
	{
		label: 'Inactive',
		icon: 'deactivated',
		data: 'Inactive',
	},
	{
		label: 'All',
		icon: 'all',
		data: 'All',
	},
];

export const existTabItems = [
	{
		label: TableStatusMap['Active'],
		icon: TableStatusMapIcon['Active'].toLowerCase(),
		data: 'Active',
	},
	{
		label: TableStatusMap['Onboarded'],
		icon: TableStatusMapIcon['Onboarded'].toLowerCase(),
		data: 'Onboarded',
	},
	{
		label: TableStatusMap['NEW_INACTIVE'],
		icon: TableStatusMapIcon['NEW_INACTIVE'].toLowerCase(),
		data: 'NEW_INACTIVE',
	},
	{
		label: TableStatusMap['W-I-P'],
		icon: TableStatusMapIcon['W-I-P']?.toLowerCase(),
		data: 'W-I-P',
	},

	{
		label: TableStatusMap['Inactive'],
		icon: TableStatusMapIcon['Inactive'].toLowerCase(),
		data: 'Inactive',
	},
	{
		label: TableStatusMap['Closed'],
		icon: TableStatusMapIcon['Closed']?.toLowerCase(),
		data: 'Closed',
	},
	{
		label: TableStatusMap['Reopened'],
		icon: TableStatusMapIcon['Reopened']?.toLowerCase(),
		data: 'Reopened',
	},
	{
		label: TableStatusMap['Deactivated'],
		icon: TableStatusMapIcon['Deactivated'].toLowerCase(),
		data: 'Deactivated',
	},
	{
		label: 'Worklist',
		icon: 'worklist_tab',
		data: 'Worklist',
	},
	{
		label: 'Draft',
		icon: 'draft',
		data: 'Drafts',
	},
	{
		label: 'Pending Submission',
		icon: 'draft',
		data: 'Pending Submission',
	},
	{
		label: 'Pending Boxing',
		icon: 'draft',
		data: 'Pending Boxing',
	},
	{
		label: 'Boxed',
		icon: 'draft',
		data: 'Boxed',
	},
	{
		label: 'Under Processing',
		icon: 'draft',
		data: 'Under Processing',
	},
	{
		label: 'Pending Payment',
		icon: 'draft',
		data: 'Pending Payment',
	},
	{
		label: 'Pending Disbursement',
		icon: 'draft',
		data: 'Pending Disbursement',
	},
	{
		label: 'Disbursed',
		icon: 'draft',
		data: 'Disbursed',
	},
	{
		label: 'Returned',
		icon: 'draft',
		data: 'Returned',
	},
	{
		label: 'Draft',
		icon: 'draft',
		data: 'Draft',
	},
	{
		label: 'All',
		icon: 'all',
		data: 'All',
	},
	{
		label: 'Went-Live',
		icon: 'draft',
		data: 'Went-Live',
	},
	{
		label: 'Inbox',
		icon: 'draft',
		data: 'Inbox',
	},
	{
		label: 'Outbound',
		icon: 'track',
		data: 'Outbound',
	},
	{
		label: 'Inbound',
		icon: 'deliver',
		data: 'Inbound',
	},
	{
		label: 'Outbox',
		icon: 'draft',
		data: 'Outbox',
	},
	{
		label: 'Handoff',
		icon: 'draft',
		data: 'Handoff',
	},
	{
		label: 'Collab',
		icon: 'collab',
		data: 'Collab',
	},
];

export const activeInactiveStatus = (status) => {
	if (status === 'Active') {
		return (
			<Box
				style={{
					// backgroundColor: '#DBF7E2', color: '#30653D',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Inactive') {
		return (
			<Box
				style={{
					// backgroundColor: '#FFE2E2', color: '#BB2222',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'W-I-P') {
		return (
			<Box
				style={{
					// backgroundColor: '#FDF7C4', color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Complete') {
		return (
			<Box
				style={{
					//  backgroundColor: '#DBF7E2', color: '#30653D',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Incomplete') {
		return (
			<Box
				style={{
					// backgroundColor: '#FFE2E2', color: '#BB2222',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Closed') {
		return (
			<Box
				style={{
					// backgroundColor: '#FFE2E2', color: '#BB2222',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'IncompleteWithWarning') {
		return (
			<Box
				style={{
					//  backgroundColor: '#FDF7C4', color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap['Incomplete']}
			</Box>
		);
	} else if (status === 'Draft' || status === 'draft') {
		return (
			<Box
				style={{
					//  backgroundColor: '#FDF7C4', color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Went-Live') {
		return (
			<Box
				style={{
					// backgroundColor: '#FDF7C4', color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	}
};

export const activeInactiveStatusWithColor = (status) => {
	if (status === 'Active') {
		return (
			<Box
				style={{
					backgroundColor: '#DBF7E2',
					color: '#30653D',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Inactive') {
		return (
			<Box
				style={{
					backgroundColor: '#FFE2E2',
					color: '#BB2222',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'W-I-P') {
		return (
			<Box
				style={{
					backgroundColor: '#FDF7C4',
					color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Complete') {
		return (
			<Box
				style={{
					backgroundColor: '#DBF7E2',
					color: '#30653D',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Incomplete') {
		return (
			<Box
				style={{
					backgroundColor: '#FFE2E2',
					color: '#BB2222',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Closed') {
		return (
			<Box
				style={{
					backgroundColor: '#FFE2E2',
					color: '#BB2222',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'IncompleteWithWarning') {
		return (
			<Box
				style={{
					backgroundColor: '#FDF7C4',
					color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap['Incomplete']}
			</Box>
		);
	} else if (status === 'Draft' || status === 'draft') {
		return (
			<Box
				style={{
					backgroundColor: '#FDF7C4',
					color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	} else if (status === 'Went-Live') {
		return (
			<Box
				style={{
					backgroundColor: '#FDF7C4',
					color: '#694500',
					textAlign: 'center',
					borderRadius: '5px',
					padding: '2px',
				}}
			>
				{TableStatusMap[status]}
			</Box>
		);
	}
};

// export const existTabItems = [
//   {
//     label: "All",
//     icon: "all",
//     data: "All",
//   },
//   {
//     label: TableStatusMap["Onboarded"],
//     icon: TableStatusMapIcon["Onboarded"].toLowerCase(),
//     data: "Onboarded",
//   },
//   {
//     label: TableStatusMap["Active"],
//     icon: TableStatusMapIcon["Active"].toLowerCase(),
//     data: "Active",
//   },
//   {
//     label: TableStatusMap["NEW_INACTIVE"],
//     icon: TableStatusMapIcon["NEW_INACTIVE"].toLowerCase(),
//     data: "NEW_INACTIVE",
//   },
//   {
//     label: TableStatusMap["NEW_VERSION_INACTIVE"],
//     icon: TableStatusMapIcon["NEW_VERSION_INACTIVE"]?.toLowerCase(),
//     data: "NEW_VERSION_INACTIVE",
//   },

//   {
//     label: TableStatusMap["Inactive"],
//     icon: TableStatusMapIcon["Inactive"].toLowerCase(),
//     data: "Inactive",
//   },
//   {
//     label: TableStatusMap["Deactivated"],
//     icon: TableStatusMapIcon["Deactivated"].toLowerCase(),
//     data: "Deactivated",
//   },
// ];

export const existEntityTabItems = [
	{
		label: TableStatusMap['Active'],
		icon: TableStatusMapIcon['Active'].toLowerCase(),
		data: 'Active',
	},
	{
		label: TableStatusMap['Inactive'],
		icon: TableStatusMapIcon['Inactive'].toLowerCase(),
		data: 'Onboarded',
	},
	{
		label: 'All',
		icon: 'all',
		data: 'All',
	},
];

export const UserTableStatusMap = {
	Onboarded: 'Onboarded',
	Pending: 'Pending',
	Cancelled: 'Cancelled',
	Revived: 'Revived',
};

export const existUserTabItems = [
	{
		label: 'All',
		icon: 'alluser',
		data: 'All',
	},
	{
		label: 'Onboarded',
		icon: UserTableStatusMap['Onboarded'].toLowerCase(),
		data: 'Onboarded',
	},
	{
		label: 'Invited',
		icon: UserTableStatusMap['Pending'].toLowerCase(),
		data: 'Pending',
	},
	{
		label: 'Revived',
		icon: UserTableStatusMap['Revived'].toLowerCase(),
		data: 'Revived',
	},
	{
		label: 'Cancelled',
		icon: UserTableStatusMap['Cancelled'].toLowerCase(),
		data: 'Cancelled',
	},
];

export const validationTextField = (e, value) => {
	let fieldName = formatName(e?.field);
	if (!value) {
		return {
			validate: false,
			message: `${fieldName} is required.`,
		};
	} else if (/^\s+$/.test(value)) {
		return {
			validated: false,
			message: `${fieldName} cannot contain only spaces.`,
		};
	} else if (/^[^\w\s]+$/.test(value)) {
		return {
			validated: false,
			message: `${fieldName} cannot contain only special characters.`,
		};
	} else if (/^\d+$/.test(value)) {
		return {
			validated: false,
			message: `${fieldName} cannot consist solely of numbers.`,
		};
	} else if (/^[\d\W_]+$/.test(value)) {
		return {
			validated: false,
			message: `${fieldName} cannot consist only special char & numbers.`,
		};
	} else {
		return {
			validated: true,
			message: '',
		};
	}
};

export const validateDateInput = (e, value) => {
	let fieldName = formatName(e?.field);

	if (!value) {
		return {
			validate: false,
			message: `${fieldName} is required.`,
		};
	} else if (/^\s+$/.test(value)) {
		return {
			validated: false,
			message: `${fieldName} cannot contain only spaces.`,
		};
	} else if (value.startsWith(' ')) {
		return {
			validated: false,
			message: 'Input starts with whitespace',
		};
	} else if (value.endsWith(' ')) {
		return { validated: false, message: 'Input ends with whitespace' };
	} else {
		return {
			validated: true,
			message: '',
		};
	}
};

export function OrderTableHead({ headCells = [] }) {
	return (
		<TableHead>
			<TableRow>
				{headCells?.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.align}
						sx={{
							py: 1.5,
							// backgroundColor: '#e5e5e5',
							backgroundColor: '#f6f5f5',
						}}
					>
						{headCell.label}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

export const actionButtonOptions = {
	Approve: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>approve </b>the case?
			</>
		),
		value: 'APPROVE',
		altCode: 'Approve',
	},
	Cancel: {
		label: (
			<>
				{' '}
				Do you want to <b style={{ fontSize: '1rem' }}>cancel </b>the case?
			</>
		),
		value: 'CANCEL',
		altCode: 'Cancel',
	},
	Delete: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>delete </b>the case?
			</>
		),
		value: 'CANCEL',
		altCode: 'Delete',
	},
	FloatforApproval: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>float </b>the case for approval?
			</>
		),
		value: 'SUBMIT',
		altCode: 'FloatforApproval',
	},
	SendforApproval: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>send </b>the case for approval?
			</>
		),
		value: 'SUBMIT',
		altCode: 'FloatforApproval',
	},
	Pass: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>pass </b>the case?
			</>
		),
		value: 'SUBMIT',
		altCode: 'Pass',
	},
	Recommend: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>recommend </b>the case?
			</>
		),
		value: 'SUBMIT',
		altCode: 'Recommend',
	},
	SaveasDraft: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>save </b>the case as draft?
			</>
		),
		value: 'SAVE',
		altCode: 'SaveasDraft',
	},
	Sendback: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>send </b>the case back?
			</>
		),
		value: 'SEND_BACK',
		altCode: 'Sendback',
	},
	Accept: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>accept </b>the case?
			</>
		),
		value: 'REJECT',
		altCode: 'Reject',
	},
	Reject: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>reject </b>the case?
			</>
		),
		value: 'REJECT',
		altCode: 'Reject',
	},
	Update: {
		label: (
			<>
				Do you want to <b style={{ fontSize: '1rem' }}>update </b>the case?
			</>
		),
		value: 'SAVE',
		altCode: 'Update',
	},
};

export const filterOptionLabel = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
export const filterChildOptionLabel = (input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase());

const inputType = [
	'label',
	'design',
	'tab',
	'section',
	'card',
	'row',
	'column',
	'checkbox',
	'checkbox_group',
	'select',
	'text',
	'radio',
	'hradio',
	'file',
	'file_table',
	'calendar',
	'time',
	'hidden',
	'textarea',
	'currency',
	'number',
	'integer',
	'password',
	'button',
	'table',
	'image',
	'texteditor',
	'announcement',
];

// const inputType = Object.keys(FormElements);

export function processFormsElements(formElements, hiddenElementsArray) {
	let result = [];
	function traverseAndExtract(node) {
		if (inputType.includes(node?.type?.toLowerCase()) && !node?.code?.includes('PROPERTY_actionOption')) {
			result.push(node);
		}
		if (node?.children && !hiddenElementsArray?.includes(node?.code)) {
			for (let child of node.children) {
				traverseAndExtract(child);
			}
		}
	}

	// Start the traversal
	formElements?.forEach((node) => traverseAndExtract(node));

	return result;
}

export function processPropertyValues(propertyValues) {
	let result = {};

	// Ensure propertyValues is an array and iterate safely
	if (Array.isArray(propertyValues)) {
		propertyValues.forEach((property) => {
			if (property && property.propertyCode && property.propertyValue !== undefined) {
				result[property.propertyCode] = property.propertyValue;
			}
		});
	}

	// Parse HiddenForm safely
	let hiddenElements = {};
	try {
		if (result['HiddenForm']) {
			hiddenElements = JSON.parse(result['HiddenForm']);
		}
	} catch (error) {
		console.error('Error parsing HiddenForm:', error);
		hiddenElements = {};
	}

	// Default final result
	let finalResult = {
		'Row-BUTTON': 'none',
		'Row-actionOption': 'none',
		// "Row-attachment": "none",
		'Row-HIDDEN': 'none',
	};

	// Process hiddenElements if it's a valid object
	if (typeof hiddenElements === 'object' && hiddenElements !== null) {
		Object.keys(hiddenElements).forEach((key) => {
			if (hiddenElements[key] === 'none') {
				finalResult[key.replace('HIDDEN_', '')] = 'none';
			}
		});
	}

	return finalResult;
}

export function processFinalPropertyValues(data) {
	let result = {};
	data.forEach((property) => {
		if (property?.propertyCode !== 'HiddenForm') {
			if (typeof property?.propertyValue === 'string' && property?.propertyValue.startsWith('[') && property?.propertyValue.endsWith(']')) {
				result[property.propertyCode] = JSON.parse(property.propertyValue);
			} else {
				result[property.propertyCode] = property.propertyValue;
			}
		}
	});
	return result;
}

export const pdfHeadCells = [
	{
		id: 'routing_name',
		align: 'left',
		disablePadding: false,
		label: 'Name',
	},
	{
		id: 'designation',
		align: 'left',
		disablePadding: false,
		label: 'Designation',
	},
	{
		id: 'role',
		align: 'left',
		disablePadding: false,
		label: 'Role',
	},
	{
		id: 'status',
		align: 'left',
		disablePadding: false,
		label: 'Status',
	},
	{
		id: 'date',
		align: 'left',
		disablePadding: false,
		label: 'Date',
	},
];
export const pdfHeadCellForSecondTable = [
	{
		id: 'routing_name',
		align: 'left',
		disablePadding: false,
		label: 'Name',
	},
	{
		id: 'designation',
		align: 'left',
		disablePadding: false,
		label: 'Siganture',
	},
	{
		id: 'date',
		align: 'left',
		disablePadding: false,
		label: 'Date',
	},
];

export const dateHandler = (creattionDateModel) => {
	const creationTime = creattionDateModel?.localDateTimeString;
	const creationDate = moment(creationTime, 'YYYY-MM-DD HH:mm:ss');
	const fourDaysAgo = moment().subtract(4, 'days');
	const threeDaysAgo = moment().subtract(3, 'days');
	const twoDaysAgo = moment().subtract(2, 'days');
	const oneDayAgo = moment().subtract(1, 'day');

	let formattedDate;
	if (fourDaysAgo.isAfter(creationDate)) {
		formattedDate = creationDate.format('D MMMM, YYYY');
	} else if (oneDayAgo.isSame(creationDate, 'day')) {
		formattedDate = 'Yesterday';
	} else if (twoDaysAgo.isSame(creationDate, 'day') || threeDaysAgo.isSame(creationDate, 'day')) {
		formattedDate = creationDate.format('dddd');
	} else {
		formattedDate = creationDate.fromNow();
	}

	return formattedDate;
};

export function dynaFormToCode(node, map = {}) {
	// If the node has a code, store the code with its label and type in the map
	if (node.code) {
		map[node.code] = {
			label: node.label,
			type: node.type,
		};
	}

	// If the node has children, recursively call the function on each child
	if (node.children && node.children.length > 0) {
		node.children.forEach((child) => dynaFormToCode(child, map));
	}

	return map;
}

export const withValueCap = (inputObj) => {
	const { formattedValue } = inputObj;
	const roundFigureAmount = formattedValue.split('.')[0];
	if (roundFigureAmount.length <= 13) return true;
	return false;
};

export const bytesToSize = (bytes) => {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;

	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	const size = bytes / Math.pow(k, i);

	return `${size.toFixed(2)} ${sizes[i]}`;
};

export const isAllowedFile = (file) => {
	// check extension
	const ext = file?.name?.split('.')?.pop()?.toLowerCase();

	if (ext) {
		if (['pdf', 'png', 'jpg', 'jpeg', 'docx', 'doc', 'pptx', 'ppt', 'xlsx', 'xls'].includes(ext)) return true;

		// optional: fallback check by MIME type
		const allowedMimeTypes = [
			'application/pdf',
			'image/png',
			'image/jpeg',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
			'application/msword', // doc
			'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
			'application/vnd.ms-powerpoint', // ppt
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
			'application/vnd.ms-excel', // xls
		];

		return allowedMimeTypes.includes(file.type);
	}

	return false;
};

export const formatNumberToCurrency = (num) => {
	if (num === null || num === undefined || num === '') return '';

	const n = Number(num);

	return isNaN(n) ? num : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
